import mergeService from './orderMerge'

export default {
  problemTypes: [
    { value: 'Missing', text: 'Missing' },
    { value: 'ShipIssue', text: 'Ship Issue' },
    { value: 'Quality', text: 'Quality' },
    { value: 'WrongPart', text: 'Wrong Product' },
    { value: 'Extra', text: 'Extra Item' },
    { value: 'MiscIssue', text: 'Misc. Issue' },
  ],
  rmaTypes: [
    { value: 'notAsDescribed', text: 'The item was not as described' },
    { value: 'size', text: 'Item too big or too small' },
    { value: 'unwanted', text: 'Customer doesn\'t want the item anymore' },
    { value: 'notOnTime', text: 'Order didn\'t arrive on time' },
    { value: 'misc', text: 'Some other reason' }
  ],
  receiveTypes: [
    { value: 'sku', text: 'SKU' },
    { value: 'notSure', text: 'Not Sure' },
    { value: 'image', text: 'Image' },
  ],

  blankLine(orderItem, qty) {
    return {
      alert: null,
      type: null,
      details: null,
      orderItem: orderItem,
      qty: qty,
      toSend: [],
      toReceive: [],
      wrongPart: [],
      userNotes: "",
      notes: "",
      restockPercent: 10,
      editIndex: null,
      refundAmount: 0,
    }
  },
  blankItem(sku, qty) {
    return {
      alert: null,
      sku: sku,
      images: [],
      imagesLater: false,
      qty: qty,
      type: 'sku',
      isKit: false,
      typeBypassed: false,
      touchInventory: true
    }
  },
  getWholeLineItem(item) {
    let items = mergeService.mergeField(item.itemType.id) === 80 ? item.kitItems : [ item ]
    return items.filter(i => !i.kit.fishbowl).map(i => ({
      type: 'sku',
      sku: mergeService.mergeField(i.sku),
      qty: mergeService.mergeField(i.qty),
      productId: i.productId.fishbowl,
      taxable: mergeService.mergeField(i.taxable),
      isKit: false,
      unitPrice: i.percentileUnitPrice ? i.percentileUnitPrice : i.unitPrice.fishbowl,
      touchInventory: true
    }))
  },

  validateLine(isHc, itemQty) {
    if (p.qty <= 0) {
      p.alert = 'Quantity must be greater than 0!'
    } else if (Number(p.qty) > itemQty) {
      p.alert = `Quantity is greater than the qty on order (${itemQty})!`
    } else if (p.type == null) {
      p.alert = `Select a ${isHc ? 'problem type' : 'RMA reason' }!`
    } else if ((p.type === 'MiscIssue' || p.type === 'misc') && (!p.details || p.details.trim(' ') === '')) {
      p.alert = 'Please fill out misc. issue details!'
    } else {
      p.qty = Number(p.qty)
      p.alert = null
    }
  },
  validateItem(i) {
    if (i.type === 'sku' && (i.sku.trim(' ') === '' || !i.productId)) {
      i.alert = 'SKU not set!'
    } else if (i.type === 'image' && i.images.filter(x => !!x).length == 0 && !i.imagesLater) {
      i.alert = 'Please upload at least 1 image'
    } else if (i.type === 'notSure' && !i.typeBypassed) {
      i.alert = "Please click Yes or No"
    } else {
      i.qty = Number(i.qty)
      i.alert = null
    }
  },

  updateRefundPrices(isHc, receiveItems, restockPercent) {
    receiveItems.forEach(item => {
      if (isHc) {
        item.unitRestockPrice = 0
        item.refundAmount = 0
      } else {
        item.unitRestockPrice = Number(item.unitPrice) * Number(restockPercent) / 100
        item.refundAmount = (Number(item.unitPrice) - Number(item.unitRestockPrice)) * Number(item.qty)
      }
    })
  },

  getItemNote(userNote, sendItems, userName) {
    let itemDetails = Object.values(Object.groupBy(sendItems, (i) => i.sku )).map((i) => {
      return `qty ${i.reduce((a,b) => a+Number(b.qty), 0)} ${i[0].sku}`
    }).join(', ')
    itemDetails = itemDetails.length > 0 ? `Please Send ${itemDetails}` : ''
    let notes = [ userNote, itemDetails ].filter(x => !!x && String(x).length > 0).join(' | ')

    let initials = `${userName.givenName[0]}${userName.familyName[0]}`
    return notes + ` - ${initials}`
  },
}



// WEBPACK FOOTER //
// /src/services/rmahc.js